import { Box, Typography } from "@mui/material";
import useIsMobile from "../hooks/useIsMobile";
import useTranslationState from "./useTranslationState";

function Hero() {
    const isMobile = useIsMobile();

    const translations = useTranslationState({
        ukoni: '',
        privateChefs: '',
        privateChefsFirstText: '',
        privateChefsServicesTitle: '',
        privateChefsEventAndMenuplaningTitle: '',
        privateChefsEventAndMenuplaningBulletpoint1: '',
        privateChefsEventAndMenuplaningBulletpoint2: '',
        privateChefsEventAndMenuplaningBulletpoint3: '',
        privateChefsEventAndMenuplaningBulletpoint4: '',
        privateChefsEventAndMenuplaningBulletpoint5: '',
        privateChefsCookTitle: '',
        privateChefsCookBulletpoint1: '',
        privateChefsCookBulletpoint2: '',
        privateChefsCookBulletpoint3: '',
        privateChefsCookingClassesTitle: '',
        privateChefsCookingClassesText: '',
        rentalChefs: '',
        rentalChefsFirstText: '',
        rentalChefsBenefitsTitle: '',
        rentalChefsBenefitsBulletpoint1: '',
        rentalChefsBenefitsBulletpoint2: '',
        rentalChefsBenefitsBulletpoint3: '',
        rentalChefsBenefitsBulletpoint4: '',
        ukoniEverythingYouWant: '',
    });

    return (
        <Box
            sx={{
                // Background from picsum
                height: 600,
                width: '100%',
                // Filter blur
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
            }}
        >
            <Box
                sx={{
                    backgroundImage: 'url(https://picsum.photos/id/999/2400/1200)',
                    backgroundSize: 'cover',
                    filter: 'brightness(0.6)',
                    height: '100%',
                    width: '100%',
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        backdropFilter: 'blur(10px)',
                        pointerEvents: 'none',
                    },
                }}
            >
            </Box>
            <Box
                sx={{
                    position: 'absolute',
                    top: 'calc(50%)',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                }}
            >
                <Typography
                    variant={isMobile ? 'h3' : 'h1'}
                    sx={{
                        color: 'white',
                        textAlign: 'center',
                        // textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                    }}
                >
                    {translations.ukoni}
                </Typography>
                <Typography
                    variant={isMobile ? 'h6' : 'h4'}
                    sx={{
                        color: 'white',
                        textAlign: 'center',
                        // Do not break words
                        whiteSpace: 'nowrap',
                    }}
                >
                    {translations.ukoniEverythingYouWant}
                </Typography>
            </Box>
        </Box>
    );
}

export default Hero;
